import { createContext, useContext } from 'react';

import { type UserContextValue } from './types';

/**
 * @deprecated see https://hello.atlassian.net/wiki/spaces/agents/pages/5666612410/Deprecating+Context+hooks+in+atlassian-studio-common
 */
export const UserContext = createContext({} as UserContextValue);

/**
 * @deprecated see https://hello.atlassian.net/wiki/spaces/agents/pages/5666612410/Deprecating+Context+hooks+in+atlassian-studio-common
 */
export const useUserContext = (): UserContextValue => {
	return useContext(UserContext);
};
